var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11004",
    "data-name": "Grupo 11004",
    transform: "translate(-723.566 -1804.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11003",
    "data-name": "Grupo 11003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_09-rating",
    "data-name": " 09-rating"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linear_color",
    "data-name": "linear color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13845",
    "data-name": "Caminho 13845",
    d: "M739.331,1814.392a.553.553,0,0,1,0,.783h0a.333.333,0,1,0,.466.477l.005-.005a1.221,1.221,0,0,0,0-1.727h0a.333.333,0,0,0-.476.466l.005.006Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13846",
    "data-name": "Caminho 13846",
    d: "M740.745,1812.978a.333.333,0,1,0-.471.472,1.886,1.886,0,0,1,0,2.666l0,0a.333.333,0,1,0,.47.473v0a2.551,2.551,0,0,0,0-3.608l0,0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13847",
    "data-name": "Caminho 13847",
    d: "M731.8,1815.176a.554.554,0,0,1,0-.784h0a.333.333,0,1,0-.46-.483l-.011.011a1.22,1.22,0,0,0,0,1.726v0a.333.333,0,0,0,.471-.472Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13848",
    "data-name": "Caminho 13848",
    d: "M730.859,1812.979a.332.332,0,0,0-.471,0h0a2.553,2.553,0,0,0,0,3.609l0,0a.333.333,0,0,0,.471-.471h0a1.886,1.886,0,0,1,0-2.666l0,0A.332.332,0,0,0,730.859,1812.979Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13849",
    "data-name": "Caminho 13849",
    d: "M739.344,1817.576a1.728,1.728,0,0,1-1.775-.341,1,1,0,0,0-1.225-.491v-1l1.3.685a.334.334,0,0,0,.484-.351l-.4-2.319,1.685-1.642a.333.333,0,0,0-.185-.569l-2.337-.34-1.039-1.9a.334.334,0,0,0-.453-.133.344.344,0,0,0-.132.133l-1.039,1.9-2.337.34a.333.333,0,0,0-.282.378.325.325,0,0,0,.1.191l1.685,1.642-.4,2.319a.336.336,0,0,0,.484.352l.86-.453v3.7c-.084-.111-.162-.21-.231-.3a1.594,1.594,0,0,0-1.543-.626,2.123,2.123,0,0,0-.783.278.336.336,0,0,0-.1.464l.016.022,2.711,3.49a.334.334,0,1,0,.527-.409h0l-2.447-3.149a1.207,1.207,0,0,1,.19-.039.938.938,0,0,1,.907.384c.2.256.479.622.817,1.087a.335.335,0,0,0,.6-.2v-5.438a.333.333,0,0,1,.667,0s0,3.579,0,3.59a.333.333,0,0,0,.663,0c0-.011,0-1.145,0-1.145a.333.333,0,0,1,.667,0v1.333a.333.333,0,1,0,.667,0v-.889a.333.333,0,0,1,.666,0v1.111a.333.333,0,1,0,.667,0v-.666a.333.333,0,1,1,.667,0v4.222a.333.333,0,0,0,.666,0v-4.222A1,1,0,0,0,739.344,1817.576Zm-4-3.334a1,1,0,0,0-1,.979l-.574.3.314-1.826a.337.337,0,0,0-.1-.3l-1.327-1.293,1.833-.267a.333.333,0,0,0,.245-.17l.826-1.511.827,1.511a.333.333,0,0,0,.244.17l1.834.267-1.327,1.293a.332.332,0,0,0-.1.3l.313,1.826-1.056-.555A1,1,0,0,0,735.344,1814.242Z",
    fill: "#000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClick);
export default __webpack_public_path__ + "static/media/icon-click.985302cbe98235c47aace5b40ff56690.svg";
export { ForwardRef as ReactComponent };